import { render, staticRenderFns } from "./EchartBarTotalCarteira.vue?vue&type=template&id=1ff959dc"
import script from "./EchartBarTotalCarteira.vue?vue&type=script&lang=js"
export * from "./EchartBarTotalCarteira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports